import { SUMMARY_TYPE_IDS } from 'reducers/mySummaryViewSlice';
import {
  checkEngagementModuleEnabled,
  checkFeedbackModuleEnabled,
  checkGoalModuleEnabled,
  checkOneOnOneModuleEnabled,
  checkReviewModuleEnabled,
  checkTaskModuleEnabled,
} from 'utils/helpers/moduleAccess';

import { MODULE_KEYS1 } from 'constants/ProjectConstants';

export const SUMMARY_TYPE_MODULES = {
  [SUMMARY_TYPE_IDS.ALL]: [
    {
      module: MODULE_KEYS1.GOAL,
      moduleEnabled: () => checkGoalModuleEnabled(),
    },
    {
      module: MODULE_KEYS1.INITIATIVE,
      moduleEnabled: () => checkTaskModuleEnabled(),
    },
    {
      module: MODULE_KEYS1.REVIEW,
      moduleEnabled: () => checkReviewModuleEnabled(),
    },
    {
      module: MODULE_KEYS1.ENGAGEMENT,
      moduleEnabled: () => checkEngagementModuleEnabled(),
    },
    {
      module: MODULE_KEYS1.ONE_ON_ONE,
      moduleEnabled: () => checkOneOnOneModuleEnabled(),
    },
    {
      module: MODULE_KEYS1.FEEDBACK,
      moduleEnabled: () => checkFeedbackModuleEnabled(),
    },
    {
      module: MODULE_KEYS1.DEVELOP,
      moduleEnabled: () => checkFeedbackModuleEnabled(),
    },
  ],
  [SUMMARY_TYPE_IDS.PERFORMANCE]: [
    {
      module: MODULE_KEYS1.GOAL,
      moduleEnabled: () => checkGoalModuleEnabled(),
    },
    {
      module: MODULE_KEYS1.INITIATIVE,
      moduleEnabled: () => checkTaskModuleEnabled(),
    },
    {
      module: MODULE_KEYS1.REVIEW,
      moduleEnabled: () => checkReviewModuleEnabled(),
    },
  ],
  [SUMMARY_TYPE_IDS.ENGAGEMENT]: [
    {
      module: MODULE_KEYS1.ENGAGEMENT,
      moduleEnabled: () => checkEngagementModuleEnabled(),
    },
  ],
  [SUMMARY_TYPE_IDS.COACHING]: [
    {
      module: MODULE_KEYS1.ONE_ON_ONE,
      moduleEnabled: () => checkOneOnOneModuleEnabled(),
    },
    {
      module: MODULE_KEYS1.FEEDBACK,
      moduleEnabled: () => checkFeedbackModuleEnabled(),
    },
    {
      module: MODULE_KEYS1.DEVELOP,
      moduleEnabled: () => checkFeedbackModuleEnabled(),
    },
  ],
};
